/* import __COLOCATED_TEMPLATE__ from './pattern-form.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './pattern-form.module.scss';

@classic
@classNames(styles.component)
export default class SharedPatternForm extends Component {}
